/*global ScrollMagic TweenMax */
/*------------------------------------*\
    #SCROLL-MAGIC
\*------------------------------------*/
WW.scrollMagic = function($) {
    'use strict';
    let runScrollMagic = () => {
        let controller,
            siteHeaderTop1,
            siteHeaderTop2,
            navbar,
            navbarBackground,
            siteLogo,
            bannerContent,
            bannerSmContent;

        controller = new ScrollMagic.Controller();



        // SITE HEADER TOP
        siteHeaderTop1 = TweenMax.to('#site-header-top', 1, {
            height: 0
        });
        new ScrollMagic.Scene({
            duration: 500
        })
        .setTween(siteHeaderTop1)
        .addTo(controller);

        siteHeaderTop2 = TweenMax.to('#site-header-top-content', 1, {
            opacity: 0,
            y: -22
        });
        new ScrollMagic.Scene({
            duration: 400
        })
        .setTween(siteHeaderTop2)
        .addTo(controller);





        // NAVBAR
        navbar = TweenMax.to('#site-nav', 1, {
            height: 55,
            lineHeight: 55 + 'px'
        });
        new ScrollMagic.Scene({
            duration: 500
            //loglevel: 3
        })
        .setTween(navbar)
        .addTo(controller);

        navbarBackground = TweenMax.to('#site-nav-background', 1, {
            opacity: 0.95
        });
        new ScrollMagic.Scene({
            duration: 500
            //loglevel: 3
        })
        .setTween(navbarBackground)
        .addTo(controller);




        //SITE LOGO
        siteLogo = TweenMax.to('#site-logo', 1, {
            width: 130,
            height: 20
        });
        new ScrollMagic.Scene({
            //triggerElement : '#siteHeader',
            duration: 500
            //loglevel: 3
        })
        .setTween(siteLogo)
        .addTo(controller);



        //BANNER CONTENT
        bannerContent = TweenMax.to('#banner-content', 1, {
            opacity: 0,
            y: -150,
            scale: .9
        });
        new ScrollMagic.Scene({
            duration: 500
        })
        .setTween(bannerContent)
        .addTo(controller);

        //BANNER CONTENT
        bannerSmContent = TweenMax.to('#banner-sm-content', 1, {
            opacity: 0,
            y: 190
        });
        new ScrollMagic.Scene({
            duration: 500
        })
        .setTween(bannerSmContent)
        .addTo(controller);

    };

    if(!this.isTouch) {
        runScrollMagic();
    }

    const debounceTime = 200;
    const efficientFn = WW.debounce(() => {
        window.requestAnimationFrame(() => {
            if(!this.isTouch) {
                runScrollMagic();
            }
        });
    }, debounceTime);
    $(window).on('resize', efficientFn);

    return this;
};